<div>
  <div class="ui-fluid">
    <p-table #dt
             [value]="model.rows"
             [globalFilterFields]="filterableColumnKeys"
             selectionMode="single"
             [lazy]="true"
             [loading]="false"
             [loadingIcon]="null"
             [showLoader]="false"
             (onLazyLoad)="lazyLoad($event)"
             [paginator]="false"
             [rows]="rows"
             [totalRecords]="rowCount"
             (onRowSelect)="rowChangePreview($event.data.id)"
             class="table-layout-fixed">
      <ng-template pTemplate="header">
        <tr class="order-list-header">
          <th id="user-list-width" [attr.width]="rowTools.width" 
              [class.user-list-customer]="params.roleId === 1"
              [class.user-list-carrier]="params.roleId === 2" 
              [class.user-list-carrier-tax]="params.roleId === 2 && params.taxIdVerified === true" 
              [class.user-list-agent]="params.roleId === 3"
              [class.user-list-default]="!params.roleId || (params.roleId !== 1 && params.roleId !== 2 && params.roleId !== 3)"
              [class.user-profile-audit]="params.roleId === 2 && params.audit === true"></th>
          <th id="user-list-sortable" *ngFor="let col of visibleColumns" [pSortableColumn]="col.sortable ? col.key : null" [attr.width]="col.width" [style.min-width]="col.width">
            <table>
              <th id="user-list-name" class="th-display-none"></th>
              <tbody>
                <tr>
                  <td style="width:22px">
                    <p-sortIconCustom *ngIf="col.sortable === true" [field]="col.key"></p-sortIconCustom>
                  </td>
                  <td>
                    {{col.name}}
                  </td>
                </tr>
              </tbody>
            </table>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="loadingbody" let-columns>
        <tr>
          <td [attr.colspan]="numColumns" class="loading-container">
            <loading></loading> Loading...
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="numColumns" style="text-align: center">
            No records found
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr [pSelectableRow]="item" [style.background-color]="rowColor(item)" (mouseenter)="hover = item.id" (mouseleave)="hover = null">
          <td class="overflow-hidden">
            <row-tools [tools]="rowToolsArr[i]" [class]="item.colourCode ? 'link-btn' : ''" [item]="item" (onSetRowColour)="setRowColour($event)" (onClick)="clickRowTools($event)" [visible]="hover == item.id" [noColor]="item.carrierStatus!=2 && item.carrierStatus!=null ? false: true"></row-tools>
          </td>
          <td *ngFor="let col of visibleColumns" [style.background-color]="getColumnStyle(col, item)" [style.color]="getColumnTextColor(col, item)">
            <dynamic-value [data]="item" [column]="col" [items]="lookups[col.lookupKey]"></dynamic-value>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <paginator-custom [rows]="dt.rows" [totalRecords]="dt.totalRecords" (onPageChange)="lazyLoad($event)" [first]="first"></paginator-custom>
  </div>
  <p-dialog [(visible)]="showModal" [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%', boxShadow:'none'}" [modal]="true" [showHeader]="false" [closable]="false">
    <user-form *ngIf="showModal" [id]="selection?.guid" (onCancel)="cancel($event)" (onSaveComplete)="onUserSaveComplete($event)"></user-form>
  </p-dialog>
  <p-dialog  #orderDialog [(visible)]="showOrderModal" [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%',boxShadow:'none'}" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
    <order-form *ngIf="showOrderModal" [dialog]="dialogRef" [id]="null" (onCancel)="cancel($event)" (onSaveComplete)="cancel($event);" [navigateOnSave]="false"></order-form>
  </p-dialog>
  <p-dialog [(visible)]="isDeleting" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false" [closable]="false">
    <div class="modal-body-custom">
      Are you sure you want to delete {{selection?.fullName}}?
    </div>
    <div class="ui-dialog ui-dialog-footer">
      <div class="modal-footer-custom">
        <div class="link-button d-inline-block">
          <a class="muted7" (click)="cancelDelete()">Cancel</a>
        </div>
        <div class="link-button float-right d-inline-block">
          <button class="link-button" type="submit" (click)="delete()">Delete</button>
        </div>
      </div>
    </div>
  </p-dialog>
  <p-dialog #locationDialog [(visible)]="showLocationModal" [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%',boxShadow:'none'}" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
    <location-form *ngIf="showLocationModal" [id]="null" (onCancel)="cancel($event)"></location-form>
  </p-dialog>
</div>

